import chatApiClient from './chatApiClient';
import { ChatRequest, ChatResponse } from './types';

export const chatService = {
  /**
   * Send a chat message and get a response
   */
  sendChatMessage: async (request: ChatRequest): Promise<ChatResponse> => {
    // Prepare the request body
    const requestBody: any = {
      message: request.message
    };
    
    // Add sessionId to body if provided (for subsequent messages)
    if (request.sessionId) {
      requestBody.sessionId = request.sessionId;
    }
    
    const response = await chatApiClient.post('/chat/' + request.botId, requestBody);
    return response.data;
  },

  /**
   * Get chat history for a session
   */
  getChatHistory: async (sessionId: string): Promise<ChatResponse[]> => {
    const response = await chatApiClient.get(`/chat/history/${sessionId}`);
    return response.data;
  },

  /**
   * Delete chat session
   */
  deleteChatSession: async (sessionId: string): Promise<void> => {
    await chatApiClient.delete(`/chat/session/${sessionId}`);
  }
};
